"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AvatarProps", {
  enumerable: true,
  get: function get() {
    return _types.AvatarProps;
  }
});
Object.defineProperty(exports, "AvatarRef", {
  enumerable: true,
  get: function get() {
    return _types.AvatarRef;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _AvatarContainer = _interopRequireDefault(require("./AvatarContainer"));

var _AvatarContent = _interopRequireDefault(require("./AvatarContent"));

var _AvatarIndicator = _interopRequireDefault(require("./AvatarIndicator"));

var _commonUIColors = require("../../utils/commonUIColors");

var _constants = require("./constants");

var _types = require("./types");

var _schema = _interopRequireDefault(require("./schema"));

var _useGravatar3 = _interopRequireDefault(require("./hooks/useGravatar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function Avatar(props, ref) {
  var ariaLabel = props['aria-label'],
      email = props.email,
      entityType = props.entityType,
      color = props.color,
      kind = props.kind,
      name = props.name,
      palette = props.palette,
      size = props.size,
      indicatorColor = props.indicatorColor;
  var translate = (0, _useTranslations.default)();

  var _useGravatar = (0, _useGravatar3.default)(props),
      _useGravatar2 = _slicedToArray(_useGravatar, 2),
      gravatarProps = _useGravatar2[0],
      shouldUseGravatar = _useGravatar2[1];

  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(kind)) window.console && // eslint-disable-next-line no-console
    console.warn('[KeyDesignSystems] The `kind` prop for the `Avatar` component has been deprecated. Use `color` + `palette` instead.'); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // This is done to not break the now deprecated `secondary` kind variant. Should be removed in the future.

  var componentColor = kind === 'secondary' ? 'licoriceMousse' : color;
  return _react.default.createElement(_AvatarContainer.default, {
    ref: ref,
    size: size,
    palette: palette,
    color: componentColor,
    shouldUseGravatar: shouldUseGravatar
  }, _react.default.createElement("span", {
    "aria-label": translate(ariaLabel, 'avatar.aria.label', {
      descriptor: name || email || entityType
    }),
    role: "img"
  }, _react.default.createElement(_AvatarContent.default, _extends({
    gravatarProps: gravatarProps,
    shouldUseGravatar: shouldUseGravatar
  }, props))), indicatorColor && indicatorColor in _commonUIColors.commonUIColors && _react.default.createElement(_AvatarIndicator.default, {
    size: size,
    color: indicatorColor
  }));
}

var AvatarWithRef = (0, _react.forwardRef)(Avatar);
AvatarWithRef.propTypes = _schema.default.propTypes;
AvatarWithRef.defaultProps = {
  email: undefined,
  entityType: _constants.entityTypes.person,
  name: undefined,
  size: _constants.sizes.medium,
  indicatorColor: undefined,
  color: 'information',
  palette: 'bright'
};
var _default = AvatarWithRef;
exports.default = _default;